import { Component, OnInit } from '@angular/core';
import { MainService } from 'app/resources/services';
import { TelefoneResidencial, TelefoneCelular, TelefoneComercial, EnderecoResidencial } from 'app/resources/classes';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';


type DadosCadastrais = {
  typeCliente: string,
  contentCliente: string,
  documento: string,
  email: string
};

@Component({
  selector: 'app-cadastro-usuario',
  templateUrl: './cadastro-usuario.component.html'
})
export class CadastroUsuarioComponent implements OnInit {
  public bootboxAlertComId: any;
  public processandoCEP: boolean;
  public bairroIsReadOnly: string | boolean;
  public ogradouroIsReadOnly: string | boolean;
  public logo: string;
  public dadosCadastrais: DadosCadastrais;
  public sexos: Array<string>;
  public documentoTipo: string;
  public etapaCadastro: number;
  public possuiAcessoAoCadastro: boolean;
  public processando: boolean;

  constructor(
    public mainService: MainService,
    public location: LocationStrategy,
    public router: Router) {

  }

  ngOnInit() {
    this.mainService.loginService.possuiCadastroUsuario().subscribe(
      sucesso => {
        this.possuiAcessoAoCadastro = sucesso.json();
        if (!this.possuiAcessoAoCadastro) {
          this.router.navigate(['']);
        }
      }, erro => {
        this.possuiAcessoAoCadastro = false;
      });

    this.processando = false;
    this.etapaCadastro = 1;
    this.documentoTipo = 'CPF';
    this.sexos = ['masculino', 'feminino'];
    this.mainService.loginService.geraLogo().subscribe(data => {
      this.logo = data.url;
    }, erro => {
    });
    const location = (<any>this.location)._platformLocation.location;
    let enderecoAcesso = (<any>this.location)._platformLocation.location.href.split('/')[3];
    let type: string;
    if (enderecoAcesso === undefined || enderecoAcesso === '#') {
      enderecoAcesso = location.hostname;
      type = 'domain';
    } else {
      type = 'context';
    }
    this.dadosCadastrais = {
      contentCliente: enderecoAcesso,
      typeCliente: type,
      documento: undefined,
      email: undefined
    };

  }

  public cadastrar() {
    this.processando = true;
    this.mainService.http.pathV2().put('api/cartoes/cartao', this.dadosCadastrais).subscribe(
      sucesso => {
        bootbox.alert('Cadastro efetuado com sucesso! \n Verifique seu e-mail para obter sua chave de acesso');
        this.processando = false;
        this.router.navigate(['']);
      }, erro => {
        bootbox.alert(erro._body);
        this.processando = false;
      }
    );
  }

  public verificaDadosInseridos(): boolean {
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/cadastro-usuario/cadastro-usuario.component.ts